import React, {useState} from "react";
import {
    TextField,
    Button,
    CircularProgress, FormLabel, RadioGroup, FormControlLabel, Radio,
} from "@mui/material";
import {useNavigate} from "react-router-dom";
import {setSuccess} from "../../../Redux/AlertReducer";
import {useDispatch} from "react-redux";
import {Helper} from "../../../tools/Helper";
import {api_Routes} from "../../../tools/api_Routes";

export const FormAddEmailProvider = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const [isLoadingSubmit, setIsLoadingSubmit] = useState(false);
    const [data, setData] = useState({
        name: "",
        driver: "",
        host: "",
        port: 0,
        username: "",
        password: "",
        encryption: "",
        from_name: "",
        from_address: "",
        priority: 0,
        daily_limit: 0,
        monthly_limit: 0,
        is_active: 0,
    });

    // Handle input changes
    const handleInputChange = (e) => {
        const {name, value} = e.target;
        setData((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoadingSubmit(true);

        const formDataToSend = new FormData();

        for (let key in data) {
            if (data[key] !== null) {
                formDataToSend.append(key, data[key]);
            }
        }

        try {
            const {result, response, message} = await Helper.Post({
                url: api_Routes.EmailProviders.Add,
                data: formDataToSend,
                isFormData: true,
            });

            setIsLoadingSubmit(false);
            if (response) {
                dispatch(setSuccess(true));
                navigate("/EmailProviders");
            }
        } catch (error) {
            console.error("An error occurred during form submission:", error);
            setIsLoadingSubmit(false);
        }
    };

    return (
        <form onSubmit={handleSubmit}>
            <div className="grid grid-cols-1 md:grid-cols-2 items-center gap-4">
                <TextField
                    fullWidth
                    margin="normal"
                    label="Name"
                    name="name"
                    required
                    type="name"
                    autoComplete="off"
                    value={data.name}
                    onChange={handleInputChange}
                    variant="outlined"
                />
                <TextField
                    fullWidth
                    margin="normal"
                    label="Driver"
                    name="driver"
                    required
                    type="text"
                    autoComplete="off"
                    value={data.driver}
                    onChange={handleInputChange}
                    variant="outlined"
                />
                <TextField
                    fullWidth
                    margin="normal"
                    label="Host"
                    name="host"
                    required
                    type="text"
                    autoComplete="off"
                    value={data.host}
                    onChange={handleInputChange}
                    variant="outlined"
                />
                <TextField
                    fullWidth
                    margin="normal"
                    label="Port"
                    name="port"
                    required
                    type="number"
                    autoComplete="off"
                    value={data.port}
                    onChange={handleInputChange}
                    variant="outlined"
                />
                <TextField
                    fullWidth
                    margin="normal"
                    label="Username"
                    name="username"
                    required
                    type="text"
                    autoComplete="off"
                    value={data.username}
                    onChange={handleInputChange}
                    variant="outlined"
                />
                <TextField
                    fullWidth
                    margin="normal"
                    label="Password"
                    name="password"
                    required
                    type="text"
                    autoComplete="off"
                    value={data.password}
                    onChange={handleInputChange}
                    variant="outlined"
                />
                <TextField
                    fullWidth
                    margin="normal"
                    label="From Name"
                    name="from_name"
                    required
                    type="text"
                    autoComplete="off"
                    value={data.from_name}
                    onChange={handleInputChange}
                    variant="outlined"
                />
                <TextField
                    fullWidth
                    margin="normal"
                    label="From Email"
                    name="from_address"
                    required
                    type="text"
                    autoComplete="off"
                    value={data.from_address}
                    onChange={handleInputChange}
                    variant="outlined"
                />
                <TextField
                    fullWidth
                    margin="normal"
                    label="Encryption"
                    name="encryption"
                    required
                    type="text"
                    autoComplete="off"
                    value={data.encryption}
                    onChange={handleInputChange}
                    variant="outlined"
                />
                <TextField
                    fullWidth
                    margin="normal"
                    label="Priority"
                    name="priority"
                    required
                    type="number"
                    autoComplete="off"
                    value={data.priority}
                    onChange={handleInputChange}
                    variant="outlined"
                />
                <TextField
                    fullWidth
                    margin="normal"
                    label="Daily Limit"
                    name="daily_limit"
                    required
                    type="number"
                    autoComplete="off"
                    value={data.daily_limit}
                    onChange={handleInputChange}
                    variant="outlined"
                />
                <TextField
                    fullWidth
                    margin="normal"
                    label="Monthly Limit"
                    name="monthly_limit"
                    required
                    type="number"
                    autoComplete="off"
                    value={data.monthly_limit}
                    onChange={handleInputChange}
                    variant="outlined"
                />
                <div className="w-full flex items-center justify-start gap-x-3">
                    <FormLabel sx={{fontWeight: "bold"}} component="legend">
                        active :
                    </FormLabel>
                    <RadioGroup
                        name="is_active"
                        value={data.is_active}
                        onChange={handleInputChange}
                        row
                    >
                        <FormControlLabel value="1" control={<Radio/>} label="Yes"/>
                        <FormControlLabel value="0" control={<Radio/>} label="No"/>
                    </RadioGroup>
                </div>
            </div>
            <Button
                type="submit"
                fullWidth
                variant="contained"
                disabled={isLoadingSubmit}
                color="primary"
                sx={{
                    display: isLoadingSubmit ? "flex" : "block",
                    marginTop: 2,
                    width: "20%",
                    marginX: "auto",
                    fontWeight: "bold",
                    justifyContent: "center",
                }}
            >
                {isLoadingSubmit ? (
                    <CircularProgress size={24} color="primary"/>
                ) : (
                    "Submit"
                )}
            </Button>
        </form>
    );
};
